<template>
  <Table
    ref="table"
    service="Expenses"
    :initialize="initialize"
    :headers="headers"
    :show-actions="false"
    :no-edit="true"
  >
    <template v-slot:actions="{ selected, exportData }">

      <v-spacer/>

      <Btn class="ml-2" @click="exportData( selected )" color="tertiary" dark>
        Exportar
      </Btn>

    </template>
  </Table>
</template>

<script>

  import Table from "@/components/core/Table.vue";
  import { userName } from '@/utils';
  import moment from "moment";

  function date(time) {
    if (time) return moment(time).format("DD/MM/YYYY");
    return "-";
  }

  export default {
    components: { Table },
    data() {
      return {
        headers: [
          { 
            text: "Fecha", 
            value: "date", 
            display: date,
            width: 100,
            filter: {
              type: "rangedate",
              compute: (value, field) => {
                if (!value[0] || !value[1]) return { [field]: null };
                return { [field]: { start: value[0], end: value[1] } };
              }
            }
          },
          {
            text: "Promotor", 
            value: "user", 
            display: v => userName( v, false ),
            filter: {
              type: 'autocomplete',
              attrs: { service: 'Users', itemText: 'name', itemValue: 'id' }
            }
          },
          {
            text: "Kms recorridos", 
            value: "kms", 
            align: 'center',
            filterable: false, 
            sorteable: false
          },
          {
            text: "Coste / km", 
            value: "costKm", 
            align: 'center',
            filterable: false, 
            sorteable: false
          },
          {
            text: "Otros gastos", 
            value: "other", 
            align: 'center',
            filterable: false, 
            sorteable: false
          },
          {
            text: "Visitas", 
            value: "visits", 
            align: 'center',
            filterable: false, 
            sorteable: false
          },
          {
            text: "Coste / visita", 
            value: "visitCost", 
            align: 'center',
            filterable: false, 
            sorteable: false
          },
          {
            text: "Campañas", 
            value: "campaignIds", 
            align: 'center',
            filterable: false, 
            sorteable: false
          },
          {
            text: "Total", 
            value: "total", 
            align: 'center', 
            filterable: false, 
            sorteable: false
          }
        ]
      };
    },
    methods: {
      initialize( params ) {
      return this.$store.dispatch( 'page', params );
    },
      edit() { return }
    },
    mounted() {
      this.$store.commit( 'setTitle', 'Informe gastos' );
    }
  };
</script>

<style>
  .error-detail {
    margin-bottom: 0 !important;
  }
  .error-detail a {
    color: white !important;
  }
  .error-detail a:hover {
    text-decoration: underline;
  }
  .error-detail:not(.open) .v-icon {
    transform: rotate(-90deg);
  }
  .error-detail:not(.open) ul {
    display: none;
  }
</style>
